function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Select, Button, Form, Input, Upload, DatePicker, Alert, notification } from 'antd';
import ImgCrop from 'antd-img-crop';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import { PlusCircleFill } from "react-bootstrap-icons";
import Common from "../../components/includes/Common";
import dayjs from 'dayjs';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var EditContestMilestone = function EditContestMilestone(_ref) {
  var _ref$milestone = _ref.milestone,
    milestone = _ref$milestone === void 0 ? null : _ref$milestone,
    handler = _ref.handler;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    cover = _useState8[0],
    setCover = _useState8[1];
  var props = {
    listType: "picture-card",
    onPreview: function onPreview(file) {
      return false;
    },
    onRemove: function onRemove(file) {
      setCover(null);
    },
    beforeUpload: function beforeUpload(file) {
      setCover(file);
      return false;
    },
    accept: ".png,.jpg,.jpeg",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    formData.append("id", milestone.id);
    formData.append('label', values.label);
    formData.append('open_at', values.open_at);
    formData.append('close_at', values.close_at);
    formData.append("description", values.description);
    formData.append('image_file', cover);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'editcontestmilestone', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue, ' + error.message);
    });
  };
  useEffect(function () {
    if (milestone == null) return;
    form.setFieldsValue({
      label: milestone.label,
      description: milestone.description,
      open_at: dayjs(milestone.open_at),
      close_at: dayjs(milestone.close_at)
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "middle",
      form: form,
      onFinish: onFinish,
      autoComplete: "off",
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          banner: true,
          closable: true,
          style: {
            marging: '5px 0px',
            fontSize: '14px'
          },
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Nouvelle image de couverture",
            children: /*#__PURE__*/_jsx(ImgCrop, {
              rotationSlider: true,
              children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    padding: "30px 90px"
                  },
                  children: /*#__PURE__*/_jsx(PlusCircleFill, {
                    size: 18
                  })
                })
              }))
            })
          })
        }), /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              lg: 12,
              sm: 12,
              md: 12,
              xs: 12,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "label",
                label: "Nom de l'\xE9tape",
                rules: [{
                  required: true,
                  message: "Veuillez entrer le nom de la compétition"
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  placeholder: "Saisir le nom"
                })
              })
            })
          }), /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 12,
              sm: 12,
              md: 12,
              xs: 12,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "open_at",
                label: "Date ouverture",
                rules: [{
                  required: true,
                  message: "Champs obligatoire"
                }],
                children: /*#__PURE__*/_jsx(DatePicker, {})
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 12,
              sm: 12,
              md: 12,
              xs: 12,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "close_at",
                label: "Date fermeture",
                rules: [{
                  required: true,
                  message: "Champs obligatoire"
                }],
                children: /*#__PURE__*/_jsx(DatePicker, {})
              })
            })]
          }), /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "description",
                label: "Description",
                children: /*#__PURE__*/_jsx(TextArea, {
                  autoSize: true,
                  maxCount: 256
                })
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: isDataLoading,
          loading: isFormLoading,
          type: "primary",
          size: "large",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "Modifier"
          })
        })
      })]
    })
  });
};
export default EditContestMilestone;